/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2019. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
"use strict";

var PHASE = {
  LOADING: "loading",
  READY: "ready",
  PRE_CREATE: "pre_create",
  CREATING: "creating",
  CREATED: "created"
};
module.exports = PHASE;